export default "__VITE_ASSET__b7931df6__"